import React, { useEffect, useState, useCallback } from "react";
import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  Image,
} from "react-native-web";
import { Images, Colors, Fonts } from "../../../../config";
import { useTranslation } from "react-i18next";
import { CAvatar, CImage } from "../../../../components/atoms";
import { formatNumber } from "../../../../helpers";
import { getClass } from "../../../../helpers/formatHelpers";

const MediaCardView = (props) => {
  const { t } = useTranslation();

  if (!props.item) return null;
  const { isMobileVersion } = props;
  const { media } = props.item;

  if (!media) return null;
  const { totalPhotoCount, totalCount, totalVideoCount } = media;
  const totalAllString = formatNumber(totalCount);
  const totalPhotoString = formatNumber(totalPhotoCount);
  const totalVideoString = formatNumber(totalVideoCount);
  const onPress = () => {
    if (props.onPress) {
      props.onPress();
    }
  };
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[styles.profileCardItemContainer, props.style]}>
      <View style={[styles.rowContainer, { flex: 7 }]}>
        <Text
          style={[
            styles.tagTitle,
            isMobileVersion ? { fontSize: 12, lineHeight: 12 } : {},
          ]}>
          <h2>{t("key_media")}</h2>
        </Text>
        <Text
          style={[
            styles.memberCountText,
            isMobileVersion ? { fontSize: 12, lineHeight: 12 } : {},
          ]}>
          {totalAllString}
        </Text>
      </View>

      <View style={[styles.rowContainer, { flex: 8 }]}>
        <Text
          style={[
            styles.grayText,
            isMobileVersion ? { fontSize: 10, lineHeight: 12 } : {},
            ,
            { marginRight: 4 },
          ]}>
          {totalPhotoString}
        </Text>
        <Text
          style={[
            styles.text,
            isMobileVersion ? { fontSize: 10, lineHeight: 12 } : {},
          ]}>
          <h3>{t("key_photo")}</h3>
        </Text>
        <View style={styles.splitter} />
        <Text
          style={[
            styles.grayText,
            isMobileVersion ? { fontSize: 10, lineHeight: 12 } : {},
            ,
            { marginRight: 4 },
          ]}>
          {totalVideoString}
        </Text>
        <Text
          style={[
            styles.text,
            isMobileVersion ? { fontSize: 10, lineHeight: 12 } : {},
            ,
            { marginRight: 4 },
          ]}>
          <h3>{t("key_video")}</h3>
        </Text>
      </View>

      <View>
        <CImage
          width={18}
          height={18}
          layout="fixed"
          source={Images.iconAngleRight}
          style={styles.angleIcon}
          resizeMode="contain"
        />
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  profileCardItemContainer: {
    height: 70,
    alignSelf: "stretch",
    borderRadius: 25,
    backgroundColor: getClass("bg-gray1"),
    marginHorizontal: 16,
    paddingHorizontal: 30,
    flexDirection: "row",
    alignItems: "center",
  },
  tagTitle: {
    fontSize: 18,
    lineHeight: 22,
    fontFamily: Fonts.primaryBold,
    color: "white",
  },
  grayText: {
    fontSize: 16,
    lineHeight: 18,
    fontFamily: Fonts.primaryBold,
    color: getClass("text-gray2"),
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  text: {
    fontSize: 16,
    lineHeight: 18,
    fontFamily: Fonts.primaryBold,
    color: "white",
  },
  angleIcon: {
    width: 16,
    height: 16,
  },
  memberCountText: {
    marginLeft: 12,
    fontSize: 18,
    lineHeight: 22,
    fontFamily: Fonts.primaryBold,
    color: getClass("text-gray2"),
  },
  splitter: {
    width: 1,
    height: 16,
    borderRadius: 1,
    backgroundColor: Colors.spliterLine,
    marginHorizontal: 6,
  },
});

export default MediaCardView;
